<template>
  <Form :model="form" style="margin-top: 40px;">
    <FormItem
      class="cc-form-item"
      label="模板名称"
      required
    >
      <Input
        class="bj-input-26262A bj-input-h45"
        style="width: 360px"
        v-model="form.name"
        placeholder="请输入模板名称"
        clearable
      ></Input>
    </FormItem>
    <FormItem class="cc-form-item" label="模板类型" required>
      <RadioGroup v-model="form.templateType" style="color: #fff" @on-change="templateTypeChange">
        <Radio class="bj-color-F85A36" :label="0"> 个人</Radio>
        <Radio class="bj-color-F85A36" :label="1"> 企业</Radio>
      </RadioGroup>
    </FormItem>
    <template v-if="templateType == 1">
      <FormItem class="cc-form-item" label="企业名称（中文）" required>
        <div class="row">
          <Select
              class="select-h45 bj-bg-color-26262A"
              v-model="form.certificateId"
              style="width: 430px"
              label-in-value
              @on-change="onEnterpriseCertificateChange"
          >
            <Option
                v-for="item in englishCertified"
                :key="item.id"
                :value="item.id"
            >{{ item.name }}</Option
            >
          </Select>
          <Button
              class="bj-search-btn-F85A36"
              style="margin-left: 20px"
              to="/my/user/myEnterprise"
          >+ 企业认证</Button
          >
        </div>
      </FormItem>
      <FormItem
                class="cc-form-item"
                label="企业名称（英文）"
                required
      >
        <Input
            class="bj-input-26262A bj-input-h45"
            style="width: 430px"
            v-model="form.intBusinessName"
            disabled
            placeholder="请输入企业名称（英文）"
            clearable
        ></Input>
      </FormItem>
    </template>

    <FormItem class="cc-form-item" label="姓名（中文）" required>
      <div class="row">
        <Select
          class="select-h45 bj-bg-color-26262A"
          v-model="form.sfz"
          style="width: 430px"
          label-in-value
          @on-change="onNameCertifiedChange"
        >
          <Option
            v-for="item in nameCertified"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <Button
          class="bj-search-btn-F85A36"
          style="margin-left: 20px"
          to="/my/user/myPersonal"
          >+ 身份认证</Button
        >
        <!-- <div class="slot">+ 身份认证</div> -->
      </div>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="姓名（英文）"
      required
    >
      <Input
        class="bj-input-26262A bj-input-h45"
        style="width: 430px"
        v-model="form.intName"
        disabled
        placeholder="请输入姓名（英文）"
        clearable
      ></Input>
    </FormItem>
    <FormItem class="cc-form-item" label="邮箱" required>
      <div class="row">
        <Select
          class="select-h45 bj-bg-color-26262A"
          v-model="form.emailId"
          style="width: 430px"
          label-in-value
          @on-change="onEmailChange"
        >
          <Option
            v-for="item in emailCertified"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <Button
          class="bj-search-btn-F85A36"
          style="margin-left: 20px"
          to="/my/user/myEmail"
          >+ 邮箱认证</Button
        >
      </div>
    </FormItem>
    <FormItem class="cc-form-item" label="国家" required>
      <Select
        class="select-h45 bj-bg-color-26262A"
        v-model="form.countryCode"
        style="width: 430px"
        :label-in-value="true"
        @on-change="changeCountry"
      >
        <Option
          v-for="item in countries"
          :key="item.id"
          :value="item.countryShortName"
          >{{ item.countryNameCn }}</Option
        >
      </Select>
    </FormItem>
    <FormItem
      v-if="form.countryCode == 'CN'"
      class="cc-form-item"
      label="省份 城市"
      required
    >
      <div class="row">
        <Select
          class="select-h45 bj-bg-color-26262A"
          v-model="form.locSp"
          filterable
          style="margin-right: 10px; width: 120px"
          @on-change="changeProvince"
        >
          <Option
            v-for="(item, index) in areas"
            :key="'p' + index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          class="select-h45 bj-bg-color-26262A"
          v-if="form.locSp != null && form.locSp != ''"
          v-model="form.locCity"
          style="margin-right: 10px; width: 120px"
          filterable
          @on-change="changeCity"
        >
          <Option
            v-for="item in cityList"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          class="select-h45 bj-bg-color-26262A"
          v-if="
            form.locSp != null &&
            form.locSp != '' &&
            form.locCity != null &&
            form.locCity != ''
          "
          v-model="form.locStreet"
          filterable
          style="width: 120px"
        >
          <Option
            v-for="item in areaList"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="联系地址"
      required
    >
      <Input
        class="bj-input-26262A bj-input-h45"
        style="width: 430px"
        v-model="form.locStreet2"
        placeholder="请输入联系地址"
        clearable
      ></Input>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="邮政编码"
      required
    >
      <Input
        class="bj-input-26262A bj-input-h45"
        style="width: 430px"
        v-model="form.postcode"
        placeholder="请输入邮政编码"
        clearable
      ></Input>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="联系手机号码"
      required
    >
      <Input
        class="bj-input-26262A bj-input-h45 bj-input-prefix"
        style="width: 430px"
        v-model="form.phone"
        placeholder="请输入联系手机号码"
        maxlength="11"
        @on-keyup="form.phone = form.phone.replace(/[^\d]/g, '')"
        clearable
      >
        <div slot="prefix" style="line-height: 45px" v-show="form.phoneCode">
          +{{ form.phoneCode }}
        </div>
      </Input>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="传真号码"
      required
    >
      <Input
        class="bj-input-26262A bj-input-h45 bj-input-prefix"
        style="width: 430px"
        v-model="form.fax"
        placeholder="请输入传真号码"
        clearable
      >
        <div slot="prefix" style="line-height: 45px" v-show="form.countryCode">
          +{{ form.countryCode }}
        </div>
      </Input>
    </FormItem>
    <div class="bj-rows">
      <Button
        class="bj-w120 bj-h45 bj-confirm-btn"
        :loading="loading"
        type="primary"
        @click="onConfirm"
        >确认提交</Button>
    </div>

  </Form>
</template>
<script>
import { getcertifiedInformation, templatesSave } from "api/domain.js";
import { mapState, mapActions, mapMutations } from "vuex";
import { pinyin } from "pinyin-pro";
export default {
  name: "templateAdd",
  data() {
    return {
      form: {
        name: "",
        templateType: 0,
        certificateId: null,
        intBusinessName: "",
        locBusinessName: "",
        sfz: null,
        locName: "",
        intName: "",
        email: "",
        emailId: "",
        countryId: "",
        country: "",
        countryCode: "", // 国家代码（传真前缀）
        phoneCode: "", // 电话前缀
        locStreet2: "", // 联系地址
        postcode: "", // 邮编
        phone: "", // 手机号码
        fax: "", // 传真号码
        locSp: "", // 省
        locCity: "", // 市
        locStreet: "", // 区
      },
      cityList: [], // 城市数据
      areaList: [], // 地区数据
      nameCertified: [], // 实名认证
      emailCertified: [], // 邮箱认证
      englishCertified: [], // 企业认证
      loading: false, // 请求中
      templateType: 0
    };
  },
  computed: {
    ...mapState(["countries", "areas"]),
    ...mapState(["templateCopy"]),
  },
  async mounted() {
    this.req_getcertifiedInformation();
    if (this.countries.length === 0) {
      await this.ACT_REGION_LIST();
    }
    if (this.templateCopy.name) {
      this.form = this.templateCopy;
      this.form.templateType = this.templateCopy.type;
      this.templateType = this.templateCopy.type;
      this.form.postcode = this.templateCopy.postCode;
      this.form.sfz = this.templateCopy.cardId;
      this.form.countryCode = this.templateCopy.cc;
      for (const i in this.areas) {
        if (this.areas[i].value === this.form.locSp) {
          this.cityList = this.areas[i].children;
          break;
        }
      }
      for (const i in this.cityList) {
        if (this.cityList[i].value === this.form.locCity) {
          this.areaList = this.cityList[i].children;
          break;
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== "userMyPersonal" &&
      to.name !== "userMyEmail" &&
      to.name !== "userMyEnterprise"
    ) {
      this.MUT_DOMAIN_TEMPLATECOPY({
        name: "",
      });
    }
    next();
  },
  methods: {
    templateTypeChange() {
      console.log(this.form.templateType)
      this.templateType = this.form.templateType
    },
    ...mapActions(["ACT_REGION_LIST"]),
    ...mapMutations(["MUT_DOMAIN_TEMPLATECOPY"]),
    async req_getcertifiedInformation() {
      try {
        const { code, data } = await getcertifiedInformation();
        if (code === 200) {
          this.nameCertified = data.sfzList;
          this.englishCertified = data.qyList;
          this.emailCertified = data.emailList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 国家改变
    changeCountry(val) {
      let data = this.countries.filter((o) => o.countryShortName === val.value);
      this.form.country = data[0].countryNameCn;
      // this.form.countryCode = data[0].countryCode;
      this.form.phoneCode = data[0].countryCode;
    },
    // 省改变
    changeProvince() {
      let selectArray = this.areas.filter(
        (o) => o.value === this.form.locSp
      );
      this.cityList = selectArray[0].children;
      this.form.locCity = "";
      this.form.locStreet = "";
    },
    // 城市改变
    changeCity() {
      if (this.form.locCity) {
        let selectArray = this.cityList.filter(
          (o) => o.value === this.form.locCity
        );
        this.areaList = selectArray[0].children;
        this.form.locStreet = "";
      }
    },
    // 企业认证发生改变
    onEnterpriseCertificateChange(value) {
      this.form.locBusinessName = value.label;
      this.form.intBusinessName = pinyin(value.label, { toneType: "none" });
    },
    // 个人认证发生改变
    onNameCertifiedChange(value) {
      this.form.locName = value.label;
      this.form.intName = pinyin(value.label, { toneType: "none" });
    },
    // 邮箱
    onEmailChange(value) {
      this.form.email = value.label;
    },
    // 提交
    async onConfirm() {
      try {
        if (!this.form.name) {
          this.$Message.warning("请输入模板名称！");
          return;
        }
        if (!this.form.templateType == null) {
          this.$Message.warning("请选择模板类型！");
          return;
        }
        if (this.form.templateType === 1) {
          if (!this.form.locBusinessName) {
            this.$Message.warning("请选择企业名称（中文）！");
            return;
          }
          if (!this.form.intBusinessName) {
            this.$Message.warning("请输入企业名称（英文）！");
            return;
          }
        }
        if (!this.form.locName) {
          this.$Message.warning("请选择姓名（中文）！");
          return;
        }
        if (!this.form.intName) {
          this.$Message.warning("请输入姓名（英文）！");
          return;
        }
        if (!this.form.emailId) {
          this.$Message.warning("请选择邮箱！");
          return;
        }
        if (!this.form.country) {
          this.$Message.warning("请选择国家！");
          return;
        }
        if (this.form.countryCode === "CN") {
          if (!this.form.locSp || !this.form.locCity || !this.form.locStreet) {
            this.$Message.warning("请选择省份-城市！");
            return;
          }
        }
        if (!this.form.locStreet2) {
          this.$Message.warning("请输入联系地址！");
          return;
        }
        if (!this.form.postcode) {
          this.$Message.warning("请输入邮政编码！");
          return;
        }
        if (!this.form.phone) {
          this.$Message.warning("请输入联系电话！");
          return;
        }
        if (!this.form.fax) {
          this.$Message.warning("请输入传真号码！");
          return;
        }
        this.loading = true;
        let params = {
          tempName: this.form.name,
          tempType: this.form.templateType,
          locName: this.form.locName,
          intName: this.form.intName,
          sfz: this.form.sfz,
          email: this.form.email,
          emailId: this.form.emailId,
          country: this.form.country,
          cc: this.form.countryCode,
          locStreet2: this.form.locStreet2,
          fax: this.form.fax,
          postCode: this.form.postcode,
          phone: this.form.phone,
          phoneCode: this.form.phoneCode,
        };
        if (this.form.templateType === 1) {
          params.certificateId = this.form.certificateId;
          params.intBusinessName = this.form.intBusinessName;
          params.locBusinessName = this.form.locBusinessName;
        }
        if (this.form.countryCode == "CN") {
          params.locSp = this.form.locSp;
          params.locCity = this.form.locCity;
          params.locStreet = this.form.locStreet;
        }
        const { code, result } = await templatesSave(params);
        if (code === 200 && result) {
          this.$Message.success("添加成功！");
          this.form = this.$options.data().form;
          this.$router.replace("/my/template");
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .ivu-form-item-label{
  min-width: 160px;
  text-align: right;
  color: #fff;
}
::v-deep .bj-input-prefix{
  .ivu-input-with-prefix{
    padding-left: 80px
  }
  .ivu-input-prefix{
    width: 80px;
  }
}
</style>
